export default "__VITE_ASSET__bt56S6O$__"